import React from 'react';
import { Link } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../styles/submission.css';
import { downloadTemplate } from '../services/bulkImportService';

const DataSubmissionPage = () => {
  return (
    <div className="container py-4">
      {/* Motivational Hero */}
      <header className="submission-hero">
        <h1 className="submission-title">Contribute Electrospinning Data</h1>
        <p className="submission-intro">
          Researchers can contribute experimental data from published electrospinning studies in a structured format.<br />
          This helps build a reusable dataset for comparison, analysis, and future data-driven research.
        </p>
      </header>

      {/* Value Proposition Grid */}
      <div className="row value-grid g-4">
        <div className="col-lg-4 col-md-6">
          <div className="value-card">
            <div className="value-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="currentColor" viewBox="0 0 16 16">
                <path d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8zm7.5-6.923c-.67.204-1.335.82-1.887 1.855A7.97 7.97 0 0 0 5.145 4H7.5V1.077zM4.09 4a9.267 9.267 0 0 1 .64-1.539 6.7 6.7 0 0 1 .597-.933A7.025 7.025 0 0 0 2.255 4H4.09zm-.582 3.5c.03-.877.138-1.718.312-2.5H1.674a6.958 6.958 0 0 0-.656 2.5h2.49zM4.847 5a12.5 12.5 0 0 0-.338 2.5H7.5V5H4.847zM8.5 5v2.5h2.99a12.495 12.495 0 0 0-.337-2.5H8.5zM4.51 8.5a12.5 12.5 0 0 0 .337 2.5H7.5V8.5H4.51zm3.99 0V11h2.653c.187-.765.306-1.608.338-2.5H8.5zM5.145 12c.138.592.325 1.132.545 1.614.552 1.035 1.218 1.65 1.886 1.855V12H5.145zm.186 2.455c.16.292.337.524.515.688a6.98 6.98 0 0 1 .64-1.539 10.363 10.363 0 0 1-.597-.933 6.95 6.95 0 0 0-.558 1.784zm1.517-.514c.16-.312.308-.667.436-1.042.13-.377.24-.783.318-1.21h-1.61c.077.427.188.833.318 1.21.128.375.276.73.436 1.042zm2.46-3.834a9.267 9.267 0 0 1-.64 1.539 6.7 6.7 0 0 1-.597.933A7.025 7.025 0 0 0 13.745 12H11.91zm1.517-1.156A12.484 12.484 0 0 0 13.91 8.5h-2.49c-.174.782-.282 1.623-.312 2.5h2.322zm-.312-7H11.23c.312.877.42 1.718.312 2.5h2.322a6.958 6.958 0 0 0-.656-2.5zm-3.56-.614c-.22-.482-.407-1.022-.545-1.614H8.5v3.46c-.67-.205-1.334-.82-1.886-1.855z" />
              </svg>
            </div>
            <h3 className="value-title">Open Data</h3>
            <p className="value-desc">
              Share experimental datasets so they can be accessed, reused, and compared by other researchers.
            </p>
          </div>
        </div>
        <div className="col-lg-4 col-md-6">
          <div className="value-card">
            <div className="value-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="currentColor" viewBox="0 0 16 16">
                <path d="M1 11a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1v-3zm5-4a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V7zm5-5a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1V2z" />
              </svg>
            </div>
            <h3 className="value-title">Structured Data</h3>
            <p className="value-desc">
              Experimental parameters and results are recorded in a consistent format, making it easier to compare studies and analyze trends.
            </p>
          </div>
        </div>
        <div className="col-lg-4 col-md-6 offset-lg-0 offset-md-3">
          <div className="value-card">
            <div className="value-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="currentColor" viewBox="0 0 16 16">
                <path d="M5.338 1.59a61.44 61.44 0 0 0-2.837.856.481.481 0 0 0-.328.39c-.554 4.157.726 7.19 2.253 9.188a10.725 10.725 0 0 0 2.287 2.233c.346.244.652.42.893.533.12.057.218.095.293.118a.55.55 0 0 0 .101.025.615.615 0 0 0 .1-.025c.076-.023.174-.061.294-.118.24-.113.547-.29.893-.533a10.726 10.726 0 0 0 2.287-2.233c1.527-1.997 2.807-5.031 2.253-9.188a.48.48 0 0 0-.328-.39c-.651-.213-1.75-.56-2.837-.855C9.552 1.29 8.531 1.067 8 1.067c-.53 0-1.552.223-2.662.524zM5.072.56C6.157.265 7.31 0 8 0s1.843.265 2.928.56c1.11.3 2.229.655 2.887.87a1.54 1.54 0 0 1 1.044 1.262c.596 4.477-.787 7.795-2.465 9.99a11.775 11.775 0 0 1-2.517 2.453 7.159 7.159 0 0 1-1.048.625c-.28.132-.581.24-.829.24s-.548-.108-.829-.24a7.158 7.158 0 0 1-1.048-.625 11.777 11.777 0 0 1-2.517-2.453C1.928 10.487.545 7.169 1.141 2.692A1.54 1.54 0 0 1 2.185 1.43 62.456 62.456 0 0 1 5.072.56z" />
                <path d="M10.854 5.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7.5 7.793l2.646-2.647a.5.5 0 0 1 .708 0z" />
              </svg>
            </div>
            <h3 className="value-title">Rigorous Validation</h3>
            <p className="value-desc">
              All contributions undergo a community review process to ensure data quality and integrity before publication.
            </p>
          </div>
        </div>
      </div>

      {/* Two ways to contribute, side by side */}
      <section className="launch-section" aria-labelledby="launch-heading">
        <h2 id="launch-heading" className="launch-heading">Contribute a Dataset</h2>
        <p className="launch-text">Choose how you want to enter your data. Both end up in the same review.</p>

        <div className="launch-options">
          <article className="launch-option">
            <div className="launch-option__icon" aria-hidden="true"><i className="bi bi-ui-checks-grid"></i></div>
            <h3 className="launch-option__title">Web form</h3>
            <p className="launch-option__best">Best for a few runs or one publication</p>
            <ul className="launch-option__points">
              <li>Guided, step by step</li>
              <li>The DOI fills in the publication details</li>
              <li>Copolymers, blends, mixed and core/shell solutions</li>
              <li>Draft saved as you go</li>
            </ul>
            <Link to="/electrospinningTable" className="btn-launch">
              <i className="bi bi-pencil-square me-2" aria-hidden="true"></i>Open the web form
            </Link>
          </article>

          <article className="launch-option">
            <div className="launch-option__icon" aria-hidden="true"><i className="bi bi-file-earmark-spreadsheet"></i></div>
            <h3 className="launch-option__title">Bulk upload</h3>
            <p className="launch-option__best">Best for many runs or several publications</p>
            <ul className="launch-option__points">
              <li>Excel template with dropdowns and notes</li>
              <li>Every cell checked before anything is saved</li>
              <li>Fix problems in the browser or in your file</li>
              <li>One contribution per DOI, automatically</li>
            </ul>
            <Link to="/bulk-upload" className="btn-launch">
              <i className="bi bi-upload me-2" aria-hidden="true"></i>Upload a spreadsheet
            </Link>
            <button type="button" className="launch-option__secondary" onClick={() => downloadTemplate().catch(() => {})}>
              <i className="bi bi-download me-1" aria-hidden="true"></i>Download the template
            </button>
          </article>
        </div>
      </section>
    </div>
  );
};

export default DataSubmissionPage;
